import firebase from "firebase";

  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyABZA1h6MsuhUBzCGYu1RTR66anoj0JhP0",
  authDomain: "ravitwittwit.firebaseapp.com",
  databaseURL: "https://ravitwittwit.firebaseio.com",
  projectId: "ravitwittwit",
  storageBucket: "ravitwittwit.appspot.com",
  messagingSenderId: "341763627362",
  appId: "1:341763627362:web:a899b002f025e8ebcdf43b",
  measurementId: "G-QKGB86YVS3"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;
